import { Capacitor, registerPlugin } from '@capacitor/core'

type NativeCredentialsPlugin = {
  getPassword(options?: { username?: string }): Promise<{
    available: boolean
    username?: string
    password?: string
    errorType?: string
    message?: string
  }>
  savePassword(options: { username: string; password: string }): Promise<{
    saved: boolean
    errorType?: string
    message?: string
  }>
}

const NativeCredentials = registerPlugin<NativeCredentialsPlugin>('NativeCredentials')

export type SavedPasswordCredential = {
  username: string
  password: string
}

export function nativeCredentialsAvailable() {
  return Capacitor.getPlatform() === 'android'
}

export async function getSavedPasswordCredential(username?: string) {
  if (!nativeCredentialsAvailable()) {
    return null
  }

  try {
    const result = await NativeCredentials.getPassword({ username })
    if (!result.available || !result.username || !result.password) {
      return null
    }

    return {
      username: result.username,
      password: result.password,
    } satisfies SavedPasswordCredential
  } catch {
    return null
  }
}

export async function saveNativePasswordCredential({
  email,
  password,
}: {
  email: string
  password: string
}) {
  if (!nativeCredentialsAvailable()) {
    return false
  }

  const username = email.trim()
  if (!username || !password) {
    return false
  }

  try {
    const result = await NativeCredentials.savePassword({ username, password })
    return result.saved
  } catch {
    return false
  }
}
